/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M4.596 1.804C5.32 1.514 6.416 1.25 8 1.25c1.645 0 3.01.546 4.235 1.036l.043.018c1.264.505 2.386.946 3.722.946 1.902 0 2.883-.425 3.268-.648a1.719 1.719 0 00.214-.144A.75.75 0 0120.75 3v11.517c0 .107 0 .28-.024.445-.022.146-.086.485-.38.724a.84.84 0 01-.032.024c-.494.359-1.772 1.04-4.314 1.04-1.645 0-3.01-.546-4.235-1.036l-.043-.018c-1.264-.505-2.386-.946-3.722-.946-1.415 0-2.32.236-2.846.446a3.322 3.322 0 00-.404.192V22a.75.75 0 01-1.5 0V3a.75.75 0 01.22-.53L4 3l-.53-.531h.001l.002-.003.004-.003.008-.009a1.31 1.31 0 01.087-.076 2.66 2.66 0 01.215-.158c.184-.123.449-.272.81-.416zm.154 1.584v10.357c.722-.265 1.774-.495 3.25-.495 1.645 0 3.01.546 4.235 1.036l.043.018c1.264.505 2.386.946 3.722.946 1.865 0 2.846-.409 3.25-.637V4.255c-.72.265-1.771.495-3.25.495-1.645 0-3.01-.546-4.235-1.036l-.043-.018C10.458 3.191 9.335 2.75 8 2.75c-1.415 0-2.32.236-2.846.446a3.317 3.317 0 00-.404.192z'
      />
    </svg>
  );
}

export default SvgFlag;
